// The file contents for the current environment will overwrite these during build.
// The build system deaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  ApiUrl: 'https://imx4api.azurewebsites.net/',
  // ApiUrl: 'http://emanapi-sandbox.azurewebsites.net/',
  // ApiUrl: 'http://absoluteapi-test.azurewebsites.net/',
  // ApiUrl: 'http://192.168.123.126:52811/',
  // ApiUrl: 'http://joffroyapi-test.azurewebsites.net/',
  // ApiUrl: 'http://localhost:55687/',
  // ApiUrl: 'http://localhost:55808/',
  // ApiUrl: 'http://localhost:50578/',
  // ApiUrl: 'http://localhost:57321/',
  // ApiUrl: 'http://localhost:64933/',
  // ApiUrl: 'http://joffroyapi-test.azurewebsites.net/',

  // ApiUrl: 'http://10.26.102.215/imx4api/', //LaredoCollege

  // ApiUrl: 'https://owapi-devteam.azurewebsites.net/',
  // ApiUrl: 'https://owapi.azurewebsites.net/',

  // ApiUrl: 'http://67.78.123.227/imexapi/',  //TMT
  // ApiUrl: 'http://67.78.123.227/imx4api/',  //TMT Public Production
  // ApiUrl: 'http://192.168.50.4/imx4api/',   //TMT Local Production

  // ApiUrl: 'http://67.78.123.227/imexsoltestapi/',  //TMT Imexsol Test

  // ApiUrl: 'http://67.78.123.227/imexapit/',   //TMT publico Sandbox debug apps
  // ApiUrl: 'http://67.78.123.227/imexapisb/',   //TMT publico Sandbox
  // ApiUrl: 'http://192.168.50.4/imexapisb/',   //TMT local Sandbox

  // ApiUrl: 'http://192.168.50.4/imexapitmtsol/',   //TMT Solutions local

  // ApiUrl: 'http://site.vintage-logistics.com:81/imx4apisb/', //vintage sandbox
  // ApiUrl: 'http://site.vintage-logistics.com:81/imexapi/', //vintage prod

  // ApiUrl: 'http://192.168.100.54/imx7api/',   //TDS local Sandbox

  // ApiUrl: 'http://216.223.185.78:7117/imx4apisb/', //EELCO Sandbox

  // ApiUrl: 'http://192.168.123.128:56015/',
  // ApiUrl: 'http://192.168.1.35:54692/',
  // ApiUrl: 'http://192.168.1.35:54692/',

  Core: {
    TransportMode: "TransportMode",
    CarrierMode: "CarrierMode",
    WhseOrderType: "WhseOrderType",
    WRecStatus: "WRecStatus",
    PickType: "PickType",
    PickStatus: "PickStatus",
    WarehouseLocationType: "WarehouseLocationType",
    WarehouseType: "WarehouseType",
    OneKeyType: "OneKeyType",
    YardReleaseType: "YardReleaseType",
    WhseDispatchType: "WhseDispatchType"
  }
};
